module.exports = __webpack_public_path__ + "img/calendar-fold.e5c44aad.svg";